// Track facebook add to cart event

import { ProductInfo } from '../../components/product_show/ProductHero/ProductHero.types'
import { envUtils } from '..'

export const trackFacebookEvent = (
  event: string,
  productInfo: ProductInfo,
  selectedPrice: string | null
) => {
  if (envUtils.isProduction() && window.fbq) {
    window.fbq('track', event, {
      content_ids: [productInfo.styleCode],
      content_type: 'product_group',
      value: selectedPrice,
      currency: productInfo.displayCurrencyCode
    })
  }
}
